import React from 'react';
import { Box } from '@mui/material';
import { announcementTypes } from '../utils';

const Label: React.FC<{
  type:
    | { id: string; name: string; color: string }
    | typeof announcementTypes[0]
    | undefined;
}> = ({ type }) => {
  if (type) {
    const { name, color } = type;
    return (
      <Box
        sx={{
          backgroundColor: color,
          color: 'white',
          borderRadius: '0.25rem',
          fontSize: '0.8rem',
          fontWeight: 'bold',
          width: '4.5rem',
          height: '1.5rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {name}
      </Box>
    );
  }
  return null;
};

export default Label;
